import React from 'react'
import PropTypes from 'prop-types'
import '../assets/css/components/source-box.css'

/**
 *  Component for displaying a source from a research task
 */
const SourceBox = props => {
  const { title, author, text } = props

  return(
    <div className='source-box'>
      <div className='title-container'>
        <span className='title-key'>Title: </span>
        <span className='title'>{title}</span>
        <span className='title-key'>Author: </span>
        <span className='title'>{author}</span>
      </div>
      <div className='source'>{text}</div>
    </div>
  )
}

SourceBox.propTypes = {
  /** The title of the source */
  title:  PropTypes.string.isRequired,
  /** The author of the source */
  author: PropTypes.string.isRequired,
  /** The full text of the source */
  text:   PropTypes.string.isRequired
}

export default SourceBox
